export type MqttConfig = Readonly<{
  brokerUrl: string;
}>;

export const MqttConfig = {
  empty: (): MqttConfig => ({
    brokerUrl: '',
  }),
};
